var _path, _ellipse, _ellipse2, _ellipse3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermanentSnowBoardPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 94,
    viewBox: "0 0 72 94",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5195 50.1882L4.56641 93.5237H59.156C71.2347 93.5237 71.0787 94.4763 71.0787 83L70.9993 30.1818C70.9993 25.5411 64.3797 24.6232 63.1007 29.0865L53.8719 61.2911C52.9588 64.4778 48.7652 65.243 46.7718 62.5868L37.2074 49.8426C35.4916 47.5562 31.9874 47.7373 30.5195 50.1882Z",
    fill: "url(#paint0_linear_4691_19008)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.4662,
    cy: 41.445,
    rx: 7.15374,
    ry: 7.10713,
    fill: "#DDEBF6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.65,
    cx: 31.7739,
    cy: 19.9211,
    rx: 7.15374,
    ry: 7.10713,
    fill: "#DDEBF6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 7.80055,
    cy: 7.60176,
    rx: 7.14918,
    ry: 7.10713,
    fill: "#DDEBF6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4691_19008",
    x1: 37.7828,
    y1: 26.8031,
    x2: 88.7064,
    y2: 144.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermanentSnowBoardPage);
export default __webpack_public_path__ + "static/media/permanentSnow-board-page.1df92529bbce57ced8cdaca2dfe4c658.svg";
export { ForwardRef as ReactComponent };